/*
  The AppWorkspace provides the landing page for the selected application workspace.
  This compoenent is typically overwritten or extended by the application.
*/
import Title from '@/agilis/components/Title/Title.vue'
import { mapActions, mapGetters } from 'vuex'
import UnStyledLink from '@/agilis/components/UnstyledLink/UnstyledLink.vue'
import Configuration from '../../util/Configuration'
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css' // https://antoniandre.github.io/splitpanes/
import PushNotificationPanel from '@/agilis/components/PushNotificationPanel/PushNotificationPanel.vue'

export default {
  name: 'AppWorkspace',

  data: () => ({
  }),

  components: {
    Title,
    UnStyledLink,
    Splitpanes,
    Pane,
    PushNotificationPanel
  },

  computed: {
    ...mapGetters({
      applicationId: 'contextStore/applicationId',
      applicationName: 'contextStore/applicationName',
      workspaceName: 'contextStore/workspaceName',
      pushMessagesShow: 'notificationStore/pushMessagesShow',
      pushMessagesPanelSize: 'notificationStore/pushMessagesPanelSize'
    }),

    workspaceId () {
      return this.$route.params.workspaceId
    },

    tabs () {
      const tabs = Configuration.getApplicationTabs(this.applicationId, this.workspaceId)
      const tabsMap = tabs.reduce((acc, t, index) => {
        acc[t.id] = Object.assign({}, t, { key: index })
        return acc
      }, {})

      return tabsMap
    },

    numberOfTabs () {
      return Object.keys(this.tabs).length
    },

    activeTab () {
      const defaultTab = Object.keys(this.tabs)[0]
      const requestedTab = this.$route.params.tabId
      return this.tabs[requestedTab] ? requestedTab : defaultTab
    },

    tabHref () {
      return tabId => {
        return this.$router.agilis.urlTab({ tabId, workspaceId: this.$route.params.workspaceId })
      }
    }

  },

  methods: {
    ...mapActions({
      setPushMessagesPanelSize: 'notificationStore/setPushMessagesPanelSize'
    }),

    handleTabChange (tabId) {
      this.$router.agilis.viewTab({
        applicationId: this.applicationId,
        workspaceId: this.$route.params.workspaceId,
        tabId
      })
    },

    computePushNotificationPanelSize (panesArray) {
      if (panesArray.length > 1 && panesArray[1].size > 0) {
        this.setPushMessagesPanelSize(panesArray[1].size)
      }
    }
  }
}
